<script setup lang="ts">
const route = useRoute()

useHead({
  title: route.meta.title || "Weg der Demokratie",
  meta: [
    {
      name: "description",
      content: (route.meta.description as string) || "Weg der Demokratie"
    }
  ]
})
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
